import { render, staticRenderFns } from "./Previews.vue?vue&type=template&id=7ca2f78a&scoped=true"
import script from "./Previews.vue?vue&type=script&lang=ts"
export * from "./Previews.vue?vue&type=script&lang=ts"
import style0 from "./Previews.vue?vue&type=style&index=0&id=7ca2f78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2f78a",
  null
  
)

export default component.exports